var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"text"}},[_c('v-img',[_c('img',{attrs:{"src":require('/src/assets/siteLogo/login.png'),"alt":"Yelli Shoes","id":"mot"}})]),_c('h2',[_vm._v("Ek baar order karke ke toe dekho!!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }